import { Component, Vue, Prop as prop, Watch as watch } from 'nuxt-property-decorator';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';

@Component
export default class MaterialSelectorFieldComponent extends Vue {
    @prop()
    private options!: OfferRefOptionContainer;

    @prop()
    private value!: string;

    public opened = false;

    faCaretDown = faCaretDown;

    public selectItem(value: string) {
        if (value !== this.value) {
            this.$emit('input', value);
        }

        this.opened = false;
    }

    public open() {
        if (this.options.options.length > 1) {
            this.opened = true;
        }
    }

    getColorStyles(colors: string[]) {
        const value = {};
        colors.forEach((color, index) => {
            value[`--c${index}`] = color;
        });
        return value;
    }

    get activeOption() {
        return this.options.options.find((el) => el.value === this.value);
    }
}
